import type { AssetType } from '@rio-cloud/rio-uikit/components/assetTree/TreeSummary';

import type { Asset, AssetStatus, Association } from '../../domain/model/assets.types';
import type * as api from './generated/assets-api';

export const mapAssetToDomain = (asset: api.Asset): Asset => ({
    assetId: asset.id,
    vehicleName: asset.name,
    status: asset.status as AssetStatus,
    type: asset.type as AssetType,
    vin: asset.identification,
    licensePlate: asset.license_plate,
    licensePlateCountryCode: asset.license_plate_country_code ?? undefined,
});

export const mapAssociationToDomain = (association: api.AssociationEmbedded): Association | undefined => {
    if (!(association._embedded && 'device' in association._embedded && association._embedded.device)) {
        return;
    }
    return {
        assetId: association.asset_id,
        device: {
            type: association._embedded.device.type,
            id: association._embedded.device.id,
            identification: association._embedded.device.identification,
        },
    };
};
